import React, { Children } from 'react';

import Box from '@mui/material/Box';

export default class RenderBlocker extends React.Component {
    shouldComponentUpdate(nextProps) {
		// console.log(nextProps)
		// for (const propName in nextProps) {
		// 	if (propName == "children") {
		// 		continue;
		// 	}

		// 	if (this.props[propName] != nextProps[propName]) {
		// 		return true;
		// 	}
		// }

		// console.log(this.props.state, nextProps.state)

		if ((this.props.state == null) != (nextProps.state == null)) {
			return true;
		}

		for (const state in nextProps.state) {
			if (this.props.state[state] != nextProps.state[state]) {
				return true;
			}
		}
		
		return false;
	}
    
    render() {
        // return <Box sx={{width: "100%", height: "100%"}}>{this.props.children}</Box>;
		return <Box sx={this.props.sx}>{this.props.children}</Box>;
    }
}